import { useEffect, useRef, useState } from "react";
import Accordion from "../../../../../components/Accordion";
import FormInput from "../../../../../components/Form/FormInput";
import FormSelectBox from "../../../../../components/Form/FormSelectBox";
import { useEmpresaGestora } from "../../../../../hooks/useEmpresaGestora";
import { EmpresaGestora } from "../../../../../types/EmpresaGestora";
import { cargarCombo } from "../../../../../services/Service";
import { FormEmpresaGestoraErrors } from "..";


type EmpresaGestoraProps = {
    empresaGestoraForm: EmpresaGestora;
    errors: FormEmpresaGestoraErrors;
    setFormErrors: (value: FormEmpresaGestoraErrors) => void
    setEmpresaGestoraForm: (value: EmpresaGestora) => void
    edit: boolean,
    view: boolean
}


const SeccionEmpresaGestora = ({ empresaGestoraForm, setFormErrors, setEmpresaGestoraForm, errors, edit, view }: EmpresaGestoraProps) => {
    const { buscarLogo } = useEmpresaGestora();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const [tiposDocPersona, setTiposDocPersona] = useState<any>([]);

    useEffect(() => {
        cargarCombo('tiposDocPersona', setTiposDocPersona);
    }, [])

    useEffect(() => {
        if (empresaGestoraForm.id !== null && empresaGestoraForm.id !== 0) {
            buscarLogo(empresaGestoraForm.id)
                .then(logo => {
                    if (logo) {
                        const objectUrl = URL.createObjectURL(logo);
                        setPreview(prev => {
                            if (prev) URL.revokeObjectURL(prev);
                            return objectUrl;
                        });
                    } else {
                        setPreview(null);
                    }
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [empresaGestoraForm.id])

    useEffect(() => {
        return () => {
            if (preview) URL.revokeObjectURL(preview);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleFileChange = () => {
        if (fileInputRef.current?.files && fileInputRef.current.files[0]) {
            const file = fileInputRef.current.files[0];
            setPreview(prev => {
                if (prev) URL.revokeObjectURL(prev);
                return URL.createObjectURL(file);
            });

            setEmpresaGestoraForm({
                ...empresaGestoraForm,
                logoNuevo: file
            })
        }
    };
    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const onChangeEmpresaGestora = (e: any) => {
        const { name, value } = e.target;
        const nuevoForm = {
            ...empresaGestoraForm,
            [name]: value
        };
        setEmpresaGestoraForm(nuevoForm)
        const nuevosErrores = validateForm(nuevoForm)
        setFormErrors(nuevosErrores)
    }

    const validateForm = (empresaGestora: EmpresaGestora) => {
        const errors: FormEmpresaGestoraErrors = {};
        if (!empresaGestora.idTipoDocPersona) {
            errors.idTipoDocPersona = "El campo Tipo de Identificación es obligatorio"
        }
        if (!empresaGestora.nroIdentificacion) {
            errors.nroIdentificacion = "El campo Número de Identificación es obligatorio"
        }
        if (!empresaGestora.nombreEmpresa) {
            errors.nombreEmpresa = "El campo Razón Social es obligatorio"
        }
        if (!empresaGestora.email) {
            errors.email = "El campo Mail es obligatorio"
        }
        return errors;
    }

    return (
        <Accordion id={'EmpresaGestora'} title="Empresa Gestora">
            <div className="pb-3">
                <div className="row mt-3">
                    <FormSelectBox
                        title={'Tipo de Identificación'}
                        label={'Tipo de Identificación'}
                        id={'idTipoDocPersona'}
                        name={'idTipoDocPersona'}
                        onChange={onChangeEmpresaGestora}
                        optionId={'id'}
                        optionLabel={'tipoDocumento'}
                        value={empresaGestoraForm.idTipoDocPersona || ''}
                        options={tiposDocPersona}
                        errorText={errors.idTipoDocPersona}
                        isDisabled={edit && view}
                    />
                    <FormInput
                        id={'nroIdentificacion'}
                        label={'Número de Identificación'}
                        name={'nroIdentificacion'}
                        value={empresaGestoraForm.nroIdentificacion || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaGestora}
                        errorText={errors.nroIdentificacion}
                        maxLength={50}
                    />
                </div>
                <div className="row mt-3">
                    <FormInput
                        id={'nombreEmpresa'}
                        label={'Razón Social'}
                        name={'nombreEmpresa'}
                        value={empresaGestoraForm.nombreEmpresa || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaGestora}
                        errorText={errors.nombreEmpresa}
                        maxLength={255}
                    />
                    <FormInput
                        id={'direccion'}
                        label={'Dirección'}
                        name={'direccion'}
                        value={empresaGestoraForm.direccion || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaGestora}
                        errorText={errors.direccion}
                        maxLength={140}
                    />
                </div>
                <div className="row mt-3">
                    <FormInput
                        id={'telefono'}
                        label={'Teléfono'}
                        name={'telefono'}
                        value={empresaGestoraForm.telefono || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaGestora}
                        errorText={errors.telefono}
                        maxLength={24}
                    />
                    <FormInput
                        id={'email'}
                        label={'Mail'}
                        name={'email'}
                        value={empresaGestoraForm.email || ''}
                        isDisabled={edit && view}
                        onChange={onChangeEmpresaGestora}
                        errorText={errors.email}
                        type='email'
                        maxLength={255}
                    />
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-6">
                    <div className="row">
                        <label className="col-form-label col-4 text-end">Logo:</label>

                        {!view &&
                            <div className="col-4 col-form-label">
                                <a href="#" onClick={() => handleButtonClick()}>
                                    <i className="fa fa-image mr-1" aria-hidden="true"></i>
                                    Agregar Logo
                                </a>
                            </div>
                        }

                        <input
                            id="file"
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            disabled={edit && view}
                        />

                        {preview &&
                            <img src={preview} style={{ width: '120px', height: '120px', padding: '10px' }} />
                        }
                    </div>
                </div>
                <div className="col-6">
                    <div className="row">
                        <FormInput
                            id={'nombreEmpresaSupervisora'}
                            label={'Empresa Supervisora'}
                            name={'nombreEmpresaSupervisora'}
                            value={empresaGestoraForm.nombreEmpresaSupervisora || ''}
                            isDisabled={true}
                            classLabel="col-form-label col-4 text-end"
                            classColumn="col-8"
                        />
                    </div>
                </div>
            </div>
            <div className="row mt-3"></div>
        </Accordion>
    )
}

export default SeccionEmpresaGestora;
